import React from 'react';
import {
  BookingSuccessfulDesc,
  BookingSuccessfulTitle,
  ChangeBtn,
  ChangeNumber,
  ContactUs,
  FormBox,
  NeedAssistance,
} from './styled';

export default function SuccessHealthPopup(props) {
  const { formSuccessData, formResponse, setFormResponse, leadsDataString } =
    props;

  const changeClickHandler = () => {
    setFormResponse([]);
    localStorage.removeItem(leadsDataString);
  };

  return (
    <FormBox>
      <img
        src="/images/tickiconlarge.svg"
        alt="tickIcon"
        width="40px"
        height="40px"
      />
      <BookingSuccessfulTitle>
        {formSuccessData?.successHeading}
      </BookingSuccessfulTitle>
      <BookingSuccessfulDesc
        dangerouslySetInnerHTML={{
          __html: formSuccessData?.successBody,
        }}
      />

      <ChangeNumber>
        <div>
          {formResponse?.map((element, index) => {
            return element?.validation_type === '2' ? (
              <strong key={`popup_${index}`}>+91 {element?.answer_text}</strong>
            ) : (
              <p key={`popup_${index}`}>{element?.answer_text}</p>
            );
          })}
        </div>
        <ChangeBtn onClick={changeClickHandler}>Change</ChangeBtn>
      </ChangeNumber>
      <NeedAssistance>
        <p>Need immediate assistance?</p>
        <ContactUs
          onClick={() => window.open(`tel:${formSuccessData?.contactNumber}`)}
        >
          {formSuccessData?.successCTAText}
        </ContactUs>
      </NeedAssistance>
    </FormBox>
  );
}
